import { ICommand } from 'core-ts-types';
import { AccountModel } from 'data-ng-authentication';
import * as _4 from 'lodash4';

export function ConversationsRoutes($stateProvider: any) {
  const conversationRouteResolve = {
    accountModelData: (accountModel: AccountModel, loadAccountCommand: ICommand) => {
      if (_4.isEmpty(accountModel.student_nk)) {
        loadAccountCommand();
      }
    }
  };

  $stateProvider
    .state('my.conversations', {
      url: 'conversations/:filter/',
      templateUrl: `capability-ng-conversations/src/views/conversation_list/conversation_list.html`,
      controller: 'ConversationListController',
      controllerAs: '$ctrl',
      params: {
        filter: {
          value: 'all'
        }
      },
      data: {
        viewTitle: 'Notifications',
        hasMainMenu: true,
        ignoredInHistory: false
      },
      resolve: conversationRouteResolve
    })
    .state('my.conversations.threads', {
      url: 'threads/{id:int}',
      views: {
        '@my': {
          templateUrl: 'capability-ng-conversations/src/views/conversation_threads/conversation_threads.html'
        }
      },
      data: {
        viewTitle: 'Notification Details',
        ignoredInHistory: false
      },
      resolve: conversationRouteResolve
    });
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-conversations/src/routes.ts